const markdownFiles = require.context('./', false, /\.md\.js$/);

export const blogPosts = markdownFiles.keys().map((fileName) => {
  const { metadata } = markdownFiles(fileName);
  return metadata;
});
